import { FileDown, Loader2 } from 'lucide-react';
import { useI18nContext } from '@/i18n/i18n-react';
import { useIsMobile } from '@/hooks/use-mobile';
import { useTenant } from '@/hooks/use-tenant';
import { Button } from '@/components/ui/button';
import { IntegrationRequiredCard } from '@/components/integration-required-card';
import { SalesHistoryList } from '@/components/sales-history/sales-history-list';
import { SalesHistoryTable } from '@/components/sales-history/sales-history-table';
import { useSalesCsv } from '@/components/sales-history/use-sales-csv';
import type { SalesHistoryFilters } from '@/components/sales-history/use-sales-history-filters';

/**
 * Analytics › Pedidos (SALES-07 AC 1–3, SALES-08 AC 5): the integration lock
 * when the store is not integrated; otherwise the card list below 768px and
 * the current table, with its Exportar button, from 768px up. The filters
 * live in the Analytics page so they survive switching tabs.
 */
export function AnalyticsOrdersTab({
  filters,
}: {
  filters: SalesHistoryFilters;
}) {
  const tenant = useTenant();
  const isMobile = useIsMobile();

  if (!tenant.isStoreIntegrationConfigured) {
    return <IntegrationRequiredCard />;
  }

  return isMobile ? (
    <SalesHistoryList filters={filters} />
  ) : (
    <DesktopOrders filters={filters} />
  );
}

function DesktopOrders({ filters }: { filters: SalesHistoryFilters }) {
  const { LL } = useI18nContext();
  const csv = useSalesCsv(filters.values);

  return (
    <div className="flex flex-col space-y-6">
      <div className="flex justify-end">
        <Button
          size="sm"
          variant="outline"
          onClick={csv.download}
          disabled={csv.isLoading}
        >
          {csv.isLoading ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <FileDown className="h-4 w-4" />
          )}
          {LL.salesPage.table.export()}
        </Button>
      </div>
      <SalesHistoryTable filters={filters} />
    </div>
  );
}
